import { useEffect, useState } from "react";

import androidStyles from "../pages/directory/PayWithFlexaAndroid.module.css";
import iosStyles from "../pages/directory/PayWithFlexaIOS.module.css";
import { readThemingCSS, readThemingCookie, setPrefersDarkTheme } from "../utils/requestTheming";
import { useIsDarkMode } from "./useIsDarkMode";
import { useIsIOS } from "./useIsIOS";

export const useTheming = (): any => {
  const [styles, setStyles] = useState(androidStyles);
  const [theme, setTheme] = useState({});
  const isIOS = useIsIOS();
  const isDark = useIsDarkMode();

  useEffect(() => {
    const styles = isIOS ? iosStyles : androidStyles;
    setStyles(styles);
  }, [isIOS]);

  useEffect(() => {
    const themingCookie = readThemingCookie(document);
    if (themingCookie) {
      const allThemes = readThemingCSS(themingCookie) || {};
      const finalTheme = allThemes[isIOS ? "iOS" : "android"][isDark ? "dark" : "light"];
      setTheme(finalTheme);
      setPrefersDarkTheme(finalTheme?.backgroundColor, finalTheme?.textColor);
    } else {
      setTheme({});
    }
  }, [isIOS, isDark]);

  return [styles, theme];
};
